module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data.access > 2) ? _c('div', {
    staticClass: "col-md-4 dragme"
  }, [_c('div', {
    staticClass: "portlet light"
  }, [_c('i', {
    staticClass: "fa fa-arrows-alt arrow-move",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "module-name"
  }, [_vm._v("Top 5 Reports")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar"
    }],
    staticClass: "portlet-body",
    staticStyle: {
      "height": "300px",
      "overflow": "hidden"
    }
  }, [(_vm.data.access > 2) ? _c('div', {
    staticClass: "table-scrollable table-scrollable-borderless"
  }, [_c('table', {
    staticClass: "table table-hover table-light"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.data.top_reports), function(item, idx) {
    return _c('tr', [_c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'Reports Preview',
          params: {
            reportid: item.id
          }
        },
        "tag": "a"
      }
    }, [_vm._v(_vm._s(item.name) + " ")])], 1)])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btn-arrow-link pull-right"
  }, [_c('router-link', {
    staticClass: "text-warning",
    attrs: {
      "to": {
        name: 'Reports Index',
        params: {
          reset: true
        }
      },
      "tag": "a"
    }
  }, [_vm._v("VIEW|EDIT\n          "), _c('i', {
    staticClass: "icon-arrow-right black"
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption caption-md"
  }, [_c('i', {
    staticClass: "icon-bar-chart font-dark hide"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption-subject font-dark bold uppercase"
  }, [_vm._v("Top 5 Reports")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "uppercase"
  }, [_c('th', [_vm._v(" REPORT NAME ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77e370d9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/TopReports.vue
// module id = 1703
// module chunks = 1